export const SET_GARAGE = 'SET_GARAGE'
export const SET_CREDIT = 'SET_CREDIT'
export const SET_CREDIT_DATA = 'SET_CREDIT_DATA'
export const SET_CAR_SELECTED = 'SET_CAR_SELECTED'
export const SET_LOAD_GARAGE = 'SET_LOAD_GARAGE'
export const SET_LOAD_CREDIT = 'SET_LOAD_CREDIT'
export const SET_COLECAO = 'SET_COLECAO'


